/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicMetadata } from './publicMetadata';

export interface WorkspaceCreate {
    name?: string;
    /**
     * Type of workspace. Ignored for public workspaces.
     */
    type?: WorkspaceCreate.TypeEnum;
    publicMetadata?: PublicMetadata;
    imageUrl?: string;
}
export namespace WorkspaceCreate {
    export const TypeEnum = {
        Personal: 'PERSONAL',
        Company: 'COMPANY'
    } as const;
    export type TypeEnum = (typeof TypeEnum)[keyof typeof TypeEnum];
}
